import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { RouterModule } from '@angular/router';
import { IndexComponent } from './index/index.component';
import { HomeRoutingModule } from './home-routing.module';
import { TestUploadComponent } from './testUpload/testUpload.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { TerceroRegistroModule } from '../datos-basicos/modules/tercero-registro/tercero-registro.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
	declarations: [
		IndexComponent,
		TestUploadComponent
	],
	imports: [
		CommonModule,
		FuseSharedModule,
		TerceroRegistroModule,
		HomeRoutingModule,
		RouterModule,
		MatCardModule,
		MatIconModule,
		MatDialogModule,
		MatSnackBarModule,
	]
})
export class HomeModule { }
